import { URLS } from '../../../consts/endpoints';
import { postData } from '../../../utils/http';
import RESPONSE_CODES from '../../../consts/responseCodes';

const splitRange = async ({ rangeId }) => {
  try {
    const response = await postData({
      url: `${URLS.EXTERNAL_NO_RANGES}/${rangeId}/split`
    });

    if (response.status === RESPONSE_CODES.SUCCESS) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export default splitRange;
